var render = function render(){var _vm=this,_c=_vm._self._c;return _c('products-form',{attrs:{"product":_vm.product,"loading":_vm.loading,"disabled":_vm.disabled,"route":"/settings/products"},on:{"update-product":_vm.updateProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }